<template>
  <ion-page>
    <ion-header :translucent="true">
      <ion-toolbar>
        <ion-buttons slot="end">
          <ion-button @click="dismiss">
            <ion-icon slot="icon-only" :icon="close"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-title>
          {{ $t('modals.languages') }}
        </ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-content :fullscreen="true">
      <div class="odn-modal-languages">
        <div
          class="odn-modal-languages-item ion-activatable"
          v-for="language in languages"
          :key="language.code"
          :class="{ active: language.code === $i18n.locale }"
          @click="selectLocale(language.code)"
        >
          <span>{{ language.label }}</span>
          <ion-ripple-effect></ion-ripple-effect>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButton,
  IonButtons,
  IonIcon,
  IonRippleEffect,
  modalController,
} from '@ionic/vue';
import { close } from 'ionicons/icons';

export default {
  name: 'ModalLanguages',
  components: {
    IonContent,
    IonHeader,
    IonPage,
    IonTitle,
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    IonRippleEffect,
  },
  data() {
    return {
      close,
    };
  },
  computed: {
    // Languages enabled server-side that the app actually bundles.
    ...mapGetters('languages', { languages: 'available' }),
  },
  methods: {
    ...mapActions('prefs', ['setLocale']),
    dismiss() {
      modalController.dismiss();
    },
    selectLocale(locale) {
      this.setLocale(locale);
      this.dismiss();
    },
  },
};
</script>

<style lang="scss">
.odn-modal {
  &-languages {
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    justify-content: stretch;

    &-item {
      position: relative;
      flex: auto;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 1rem 2rem;
      cursor: pointer;

      &.active {
        color: var(--ion-color-primary);
        background-color: rgba(var(--ion-color-primary-rgb), 0.1);
      }
    }
  }
}
</style>
